export enum UserMenuTypes {
  MOBILE = 'MOBILE',
  DESKTOP = 'DESKTOP'
}
